import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

interface CartGroupProps {
    withNoTitle?: boolean;
    hasErrorBorder?: boolean;
    allowOverflow?: boolean;
}

export const CartGroup = styled.div<CartGroupProps>(
    ({ theme, withNoTitle = false, hasErrorBorder = false, allowOverflow = false }) => ({
        backgroundColor: theme.colors[theme.colorMode].background_Primary,
        margin: `0 ${theme.spacing.medium}`,
        boxShadow: "none",
        borderRadius: theme.cornerRadius.medium,
        border: hasErrorBorder ? `1.5px solid ${theme.colors.IG_Primary}` : "",
        padding: withNoTitle
            ? `${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.large} ${theme.spacing.medium}`
            : `${theme.spacing.large} ${theme.spacing.medium}`,
        overflow: allowOverflow ? "visible" : "hidden",
    }),
);

export const CartGroupHeader = styled.div(({ theme }) => ({
    padding: `0 ${theme.spacing.large}`,
    marginBottom: theme.spacing.medium,
}));

export const CartGroupHeaderTitle = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_High_Emphasis,
    margin: 0,
}));
